/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';
export default (function (_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 42 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4147_15812",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "42",
    height: "48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4147_15812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8727 8.7469C31.1115 8.70494 33.0242 6.03171 32.013 6.33386C31.6322 6.39681 31.4429 6.61504 31.6107 6.91089C31.0836 6.5353 31.2535 7.55717 30.8921 7.62012C30.6468 7.23823 30.6791 8.5035 30.4682 8.06286C27.6089 10.1884 25.6575 18.1305 29.9605 10.2933C29.2032 10.755 29.655 10.0667 30.0014 9.86531C30.0164 10.6459 30.8125 9.17706 30.8835 8.83294C30.5349 9.18965 30.8211 8.32305 30.8706 8.7469H30.8727Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4539 9.44771C22.7616 9.10779 21.8924 5.59104 21.8515 5.21544C21.6105 4.42858 20.8145 5.12521 21.1393 5.67916C21.1544 5.81345 21.5782 6.64018 21.1523 6.52478C20.651 7.28856 21.7009 8.4804 21.2297 9.07841C21.4664 9.13926 21.4535 9.50015 21.5976 9.5547C21.419 9.69529 21.546 9.99324 21.6041 9.97436C21.4771 11.1914 22.9939 11.0004 22.5572 9.85687C22.6196 9.86316 22.6648 9.54211 22.4561 9.44979L22.4539 9.44771Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89582 13.5226C9.97328 14.171 9.60108 13.7702 9.56665 13.4534C10.1648 13.5184 9.38593 12.763 9.09763 12.656C9.16217 12.7505 9.03523 12.8994 8.89108 12.7127C9.38162 12.5364 7.53133 10.1968 7.64106 11.8985C7.67548 11.9363 7.99391 11.716 7.93797 11.8356C7.413 12.1189 8.03694 12.2259 8.15742 12.2993C7.91646 12.484 8.21982 12.4063 8.14236 12.5092C7.71636 12.6372 8.74693 12.7987 8.31017 12.9078C8.26284 13.8122 9.7818 14.341 9.67423 15.0879C10.4445 14.9432 11.0533 17.2429 11.5353 15.7951C11.1588 14.8928 10.7908 14.2004 9.89582 13.5226Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7204 4.88812C10.8297 5.2847 12.3163 6.72834 12.3744 7.3914C12.3787 8.2454 15.5694 14.962 15.8039 12.3853C14.8207 10.3605 14.3775 8.53286 12.8671 6.22473C12.6498 5.83235 12.198 4.43909 11.7204 4.88812Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3961 16.4875C32.4671 17.4003 31.2494 17.1547 31.2537 17.9479C31.4279 19.3391 37.1337 15.3523 36.1612 14.5508C35.2296 13.9717 33.076 16.5253 32.3961 16.4875Z",
    fill: secondaryColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.8656 15.2719L21.3193 19.0913V29.2763L30.8656 33.0957V15.2719Z",
    fill: "#101214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7649 19.7256V28.6244H18.773V34.3644H14.9537V28.6244H11.1343V19.7256H23.7649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.765 19.7256H21.3193V28.62H23.765V19.7256Z",
    fill: primaryColor
  }));
});